const icon = require('vue-svgicon');
icon.register({
    'search': {
        width: 16,
        height: 16,
        viewBox: '0 0 20 20',
        data: `<path pid="0" d="M13.311 14.04l.707-.706 5.657 5.657-.707.707z"/><path pid="1" d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z"/>`,
    },
});
